import type { ModuleId } from "@wato/business-types";
import type { MessageKey } from "@wato/i18n";

/** OWN-333: the six original modules keep their old keys; products/services/documents live under b29b. */
export function moduleNameKey(id: ModuleId): MessageKey {
  switch (id) {
    case "products":
    case "services":
    case "documents":
      return `workspace.b29b.modules.names.${id}`;
    case "accounts":
    case "travel":
    case "store":
    case "quotes":
    case "tables":
    case "bookings":
      return `workspace.modules.names.${id}`;
  }
}

export function moduleDescriptionKey(id: ModuleId): MessageKey {
  switch (id) {
    case "products":
    case "services":
    case "documents":
      return `workspace.b29b.modules.descriptions.${id}`;
    case "accounts":
    case "travel":
    case "store":
    case "quotes":
    case "tables":
    case "bookings":
      return `workspace.modules.descriptions.${id}`;
  }
}
